/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PowerDto } from './powerDto';

export interface UnitDto { 
    uuid?: string;
    name?: string;
    names?: { [key: string]: string; };
    descriptions?: { [key: string]: string; };
    visible?: boolean;
    type?: UnitDto.TypeEnum;
    rank?: number;
    rank1Power?: PowerDto;
    rank2Power?: PowerDto;
    rank3Power?: PowerDto;
    rank4Power?: PowerDto;
}
export namespace UnitDto {
    export type TypeEnum = 'Infantry' | 'Mounted' | 'Artillery' | 'Aircraft';
    export const TypeEnum = {
        Infantry: 'Infantry' as TypeEnum,
        Mounted: 'Mounted' as TypeEnum,
        Artillery: 'Artillery' as TypeEnum,
        Aircraft: 'Aircraft' as TypeEnum
    };
}